import { Suspense, lazy } from 'react'
import { Route, Routes } from 'react-router-dom'

const KvkkPage = lazy(() => import('pages/KvkkPage'))
const AboutPage = lazy(() => import('pages/AboutPage'))
const DisclaimerPage = lazy(() => import('pages/DisclaimerPage'))
const SecurityStatementPage = lazy(() => import('pages/SecurityStatementPage'))
const VisionAndMissionPage = lazy(() => import('pages/VisionAndMissionPage'))
const NotAvailablePage = lazy(() => import('pages/NotAvailablePage'))

function App() {
  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path="/xhcpstatics/kvkk" element={<KvkkPage />} />
        <Route path="/xhcpstatics/about" element={<AboutPage />} />
        <Route path="/xhcpstatics/disclaimer" element={<DisclaimerPage />} />
        <Route
          path="/xhcpstatics/securitystatement"
          element={<SecurityStatementPage />}
        />
        <Route
          path="/xhcpstatics/visionandmission"
          element={<VisionAndMissionPage />}
        />
        <Route path="*" element={<NotAvailablePage />} />
      </Routes>
    </Suspense>
  )
}

export default App
